export interface IRegistrationDuplicateCheck {
	isRegistrationNumberInUse: boolean;
	isCompanyNameInUse: boolean;
}

export type DuplicateConfirmationOutcome = "none" | "confirmed" | "cancelled";

export async function evaluateDuplicateRegistrationConfirmation(
	check: () => Promise<IRegistrationDuplicateCheck>,
	confirm: () => Promise<boolean>,
): Promise<DuplicateConfirmationOutcome> {
	const { isRegistrationNumberInUse, isCompanyNameInUse } = await check();

	if (!isRegistrationNumberInUse && !isCompanyNameInUse) return "none";

	return (await confirm()) ? "confirmed" : "cancelled";
}
